import React from "react";

export default function Monogram({ size = "md", className = "" }) {
  const cls = size === "lg" ? "monogram monogram-lg" : "monogram";
  const style = size === "sm" ? { width: 38, height: 38, fontSize: "0.95rem" } : undefined;
  return (
    <span className={`${cls} ${className}`} style={style} aria-label="OP — Osvaldo Paiva" data-testid="monogram-op">
      OP
    </span>
  );
}
